// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Qudv","row":"Node_row__3cspN","label":"Node_label__3dLfd","footer":"Node_footer__1kyjr"};